import {
  CustomAutoComplete,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import { RECEIPT_TYPE_OPTIONS } from '../../constants/supplierLedgerUiConstants';
import {
  FieldSelect,
  invoiceCompactGridSx,
  invoiceFieldSpan,
} from '../SupplierLedgerShared';

const SupplierInvoiceProviderSection = ({
  form,
  isEditMode,
  locksFinancialFields,
  onChange,
  providerOptions,
}) => (
  <DrawerFormSection title="Proveedor y comprobante" contentSx={invoiceCompactGridSx}>
    <CustomAutoComplete
      label="Proveedor"
      name="uuid_legal_entity"
      value={form.uuid_legal_entity}
      onChange={onChange}
      options={providerOptions}
      inputPlaceholder="Buscar proveedor"
      disabled={isEditMode}
      sx={invoiceFieldSpan(12, 2)}
    />
    <CustomTextField
      label="Fecha"
      type="date"
      name="invoice_date"
      value={form.invoice_date}
      onChange={onChange}
      shrinkLabel
      sx={invoiceFieldSpan(6)}
    />
    <CustomTextField
      label="Vencimiento"
      type="date"
      name="due_date"
      value={form.due_date}
      onChange={onChange}
      shrinkLabel
      sx={invoiceFieldSpan(6)}
    />
    <FieldSelect
      label="Tipo"
      name="receipt_type"
      value={form.receipt_type}
      onChange={onChange}
      options={RECEIPT_TYPE_OPTIONS}
      sx={{ ...invoiceFieldSpan(4), pointerEvents: locksFinancialFields ? 'none' : 'auto', opacity: locksFinancialFields ? 0.65 : 1 }}
    />
    <CustomTextField
      label="Comprobante"
      name="receipt_number"
      value={form.receipt_number}
      onChange={onChange}
      disabled={locksFinancialFields}
      sx={invoiceFieldSpan(8)}
    />
  </DrawerFormSection>
);

export default SupplierInvoiceProviderSection;
